import { all } from "redux-saga/effects";

import songsSagas from "./songs/songs.sagas";
import userSagas from "./user/user.saga";
import playlistSagas from "./playlists/playlists.saga";

export default function* rootSaga() {
  yield all([...userSagas, ...songsSagas, ...playlistSagas]);
}
